<template>
  <div>
    <div>
        <Header></Header>
      <keep-alive>
          <router-view ></router-view>
      </keep-alive>
      <mu-container style="width:100%;position:fixed;bottom:0;padding:0;z-index:10000;">
        <mu-tabs @change="selectTab"  inverse    full-width>
          <mu-tab>
            <mu-icon value="home"></mu-icon>
            首页
          </mu-tab>
          <mu-tab>
            <mu-icon value="show_chart"></mu-icon>
            行情
          </mu-tab>
           <mu-tab>
             <mu-icon value="book"></mu-icon>
            资讯
          </mu-tab>

            <mu-tab>
             <mu-icon value="more"></mu-icon>
            关于
          </mu-tab>
       
       
          <mu-tab>
            <mu-icon value="person"></mu-icon>
            我的
          </mu-tab>
        </mu-tabs>
      </mu-container>

    </div>
    <!--
      <mt-popup style="z-index:1000;" v-model= "showgonggao" class="ggbox">
      <div class="gtitle">公告</div>
      <div class="gcontent">{{this.$store.state.gonggao2}}</div>
      <div class="gaction">
        <mt-button size="small" type="danger" @click="closepop">关闭</mt-button>
      </div>
    </mt-popup>
    -->
  </div>
</template>

<script>
//import My from "@/pages/My.vue";
//import Index from "@/pages/Index_sf.vue";
//import Market from "@/pages/Market.vue";
//import TradeView from '@/pages/TradeView.vue'
import Header from '@/components/Header.vue'



var tabs = ['/home/index','/home/market','/home/news','/home/about','/home/my'];

import api from "@/api.js";

export default {
  data: function() {
    return {
      tabIndex: 0,
      currTab: tabs[0],
      saveVisible: false,
      countdown: -1,
      first: true,
      showGonggao: true,
     
    };
  },
  components:{
      Header
  },
  computed: {
     gonggao() {
        if(this.$store) {
          return this.$store.state.gonggao;
        }
        return "";
        
    },
    showgonggao(){
      if(this.$store) {
         return this.$store.state.showgong;
      }
    }
  },
  methods: {
    selectTab: function(tabIndex) {
      
      this.tabIndex = tabIndex;
      this.currTab = tabs[tabIndex];
      if(tabIndex==1 || tabIndex==4){
          if(!this.$store.state.user ){
              this.$router.push("/login")
              return;
          }
          if(!this.$store.state.user.active){
             this.$router.push("/login");
             this.$toast("您的账号已被冻结,请联系客服");
          }
      }
      this.$router.push(this.currTab);
    },
    toTrade(){
      //this.tabIndex=3;
      this.selectTab(4);
    },
    toService(){
      //this.tabIndex=2;
      this.selectTab(3);
    },
  closepop(){
    //this.showGonggao=false;
      this.$store.state.showgong=false;
    }
  },

  mounted() {
    let index = this.$route.params.tid;
    window.toTrade=this.toTrade;
    window.toService=this.toService;
    //this.showGonggao=this.$store.state.showgong;
    console.log("index:" + index);
    if (index) {
      this.selectTab(index);
    }
    


    var self = this;
  },
  beforeRouteLeave(to, from, next) {
    console.log(to.path);

    next();
  }
};
</script>

<style scoped>
footer.tabbar {
  position: fixed;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 999;
  width: 100%;
  height: 56px;
  background: #26292f;
}

footer.tabbar ul {
  display: flex;
}

footer.tabbar li {
  flex: 1;
  position: relative;
  text-align: center;
  line-height: 0;
}

footer.tabbar li img {
  display: inline-block;
  margin-top: 6px;
  width: 25px;
  height: 25px;
  font-size: 0;
}

footer.tabbar li h6 {
  margin-top: 3px;
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  color: #797a7c;
}

footer.tabbar li h6.active {
  color: #ff3d6f;
  background-color: transparent;
}

.fullscreen-box {
  position: absolute;
  z-index: 9999;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
}

.fullscreen-box img {
  width: 100%;
  height: 100%;
}

.fullscreen-box span {
  position: absolute;
  top: 15px;
  right: 15px;
  width: 30px;
  height: 30px;
  line-height: 30px;
  background: #797a7c;
  color: #aaa;
  border-radius: 50%;
  text-align: center;
}

.saveBox {
  width: 100%;
  height: 60px;
}

.saveBox.mint-popup {
  background: transparent;
}

.popbox {
  margin: 0 15px 5px 15px;
  height: 55px;
  position: relative;
  color: #444;
  font-size: 16px;
}

.popbox h6 {
  display: block;
  height: 40px;
  line-height: 40px;
  padding: 0 10px;
  background: #fff;
  border-radius: 10px;
  text-align: left;
}

.popbox cite {
  position: absolute;
  bottom: 8px;
  left: 50%;
  margin-left: -8px;
  display: block;
  width: 15px;
  height: 15px;
  background: #fff;
  transform: rotate(45deg);
}

.popbox img {
  width: 26px;
  height: 26px;
  vertical-align: middle;
}

.popbox img.homelogo {
  margin-right: 10px;
}
.ggbox {
  width: 75vw;
  min-height: 50vw;
  padding: 10px;
  border-radius: 10px;
  background-color: white;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
.gtitle {
  text-align: left;
  color: black;
}
.gcontent {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  color: #444;
}
.gaction {
  display: flex;
  justify-content: flex-end;
  align-self: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/pages/Home_hs.vue